<template>
  <div class="all_times_chart_container">
    <div class="menu-wrapper" :class="{ not_reversed_scroll: isTranslate }">
      <ul
        class="sub-menu-dropup right-list-rotate"
        :class="{ not_reversed_ul: isTranslate }"
      >
        <li
          @click="kobiSelectedItem = index"
          :class="{ active: kobiSelectedItem == index }"
          :key="index"
          v-for="(item, index) in kobiTags"
          class="dropdown-item btn btn-block btn-light-gray dp"
        >
          <span class="">{{ item }}</span>
        </li>
      </ul>
    </div>
    <div class="styleCard-big">
      <div class="styleCardContentChart flex padding">
        <ul class="date-nav style3">
          <li
            v-for="tab in timeRanges"
            :key="tab.id"
            :class="{ active: selectedDateRange === tab.alias }"
            @click="
              () => {
                selectedDateRange = tab.alias;
              }
            "
          >
            {{ tab.name }}
          </li>
        </ul>
        <div class="time-users-chart">
          <canvas width="1" id="tasks-time-chart-big"></canvas>
        </div>
        <div class="time-total-chart">
          <canvas width="1" id="tasks-total-time-chart-big"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hoursFormatterUtil from "@/mixins/system/hoursFormatterUtil";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import { mapGetters, mapState } from "vuex";
import apiClientCreator from "@/helpers/api/request";
import moment from "moment";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "TimesChart.component",
  mixins: [hoursFormatterUtil, UsersPermissionCheck],
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("tasks", ["getChartQueryObject"]),
    ...mapState("tasks", ["queryForCharts", "resetQuery"])
  },
  data() {
    return {
      kobiTags: ["item 1", "item 2", "menu 3", "tasks 4", "item 5", "viki 6"],
      kobiSelectedItem: 0,
      TimeChartBarPerc: {
        type: "bar",
        options: {
          tooltips: {
            enabled: true,
            mode: "single",
            callbacks: {
              label: (tooltipItems, data, value) => {
                return (
                  data.datasets[tooltipItems.datasetIndex].label +
                  ": " +
                  this.hoursFormatter(tooltipItems.yLabel)
                );
              }
            }
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 15,
              bottom: 0
            }
          },

          plugins: {
            datalabels: {
              align: "end",
              anchor: "end",
              offset: -5,
              font: {
                family: "Montserrat"
              },
              fontSize: 1,
              color: function(context) {
                var index = context.dataIndex;
                var value = context.dataset.data[index];
                return value < 0
                  ? "red" // draw negative values in red
                  : context.dataset.borderColor;
                // :"white";
                //return context.dataset.borderColor;
              },
              formatter: function(value, index, values) {
                // return value.toFixed(0);
                return "";
                // value = value.toString();
                // value = value.split(".").join("");
                // value = parseInt(value);
                // return value === 0 ? "" :""// value; // hide numbers - show none
              }
            }
          },

          maintainAspectRatio: true,
          gradientColors: [
            "rgba(29,140,248,0.2)",
            "rgba(29,140,248,0.0)",
            "rgba(29,140,248,0)"
          ],
          gradientStops: [1, 0.4, 0],
          responsive: true,
          scales: {
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "rgba(70,204,253,0.22)" //"rgba(70,204,253,0.22)",
                },
                ticks: {
                  beginAtZero: true,
                  display:false,
                  padding: 10,
                  fontColor: "transparent", //"#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 1
                }
              }
            ],
            xAxes: [
              {
                stacked: true,
                id: "bar-x-axis1",
                // barPercentage: 1.0,
                // categoryPercentage: 0.5,
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent"
                },
                ticks: {
                  padding: 1,
                  fontColor: "#44A2D2",
                  fontFamily: "Montserrat",
                  fontSize: 10
                }
              }
            ]
          },
          legend: {
            display: false
          },

          hover: {
            onHover: function(e) {
              const point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = "pointer";
              else e.target.style.cursor = "default";
            }
          }
        }
      },

      selectedDateRange: null,
      timeRanges: [
        {
          id: 1,
          name: "T",
          alias: "TODAY"
        },
        {
          id: 2,
          name: "Y",
          alias: "YESTERDAY"
        },
        {
          id: 3,
          name: "T-W",
          alias: "WEEK"
        },
        {
          id: 4,
          name: "L-W",
          alias: "LAST_WEEK"
        },
        {
          id: 5,
          name: "T-M",
          alias: "MONTH"
        },
        {
          id: 6,
          name: "L-M",
          alias: "LAST_MONTH"
        },
        {
          id: 7,
          name: "Q",
          alias: "QUARTER"
        },
        {
          id: 8,
          name: "H-Y",
          alias: "HALF_YEAR"
        },
        {
          id: 8,
          name: "Y",
          alias: "YEAR"
        }
      ],
      ArTasksTimeData: [],
      reqTasksTime: false,
      queryObject: {},

      TasksTimeChartBuild: null,
      TasksTimeTotalChartBuild: null
    };
  },
  mounted() {
    this.defaultPresets("YEAR");
  },
  watch: {
    resetQuery: function() {
      if (this.resetQuery) {
        this.selectedDateRange = null;
        this.$store.commit("tasks/setResetQuery", false);
      }
    },
    getChartQueryObject: function() {
      this.fetchTasksTimeChart();
    },
    selectedDateRange: function() {
      if (this.selectedDateRange) {
        this.$store.commit("tasks/setChartDataToTable", {
          dates: this.defaultPresets()
        });
      }
    }
  },
  methods: {
    adjustNumbersToFitDataChart(number){
      // if (`${number.toFixed(2)}`.length > 2) {
      //   let len = `${number}`.length;
      //   switch (len) {
      //     case 3:
      //       number = (number / 10).toFixed(1);
      //       break;
      //     case 4:
      //       number = (number / 100).toFixed(2);
      //       break;
      //     case 5:
      //       number = (number / 1000).toFixed(3);
      //       break;
      //     case 6:
      //       number = (number / 10000).toFixed(4);
      //       break;
      //   }
      // }
      let percision = 0;
      for(let i=1;number>10 || number < -10;i++){
        number/=10;
        percision = i;
      }
      number = number.toFixed(percision);
      return number;
    },

    defaultPresets(range = this.selectedDateRange) {
      if (range === "TODAY") {
        const today = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: today,
            end: today
          }
        };
      }
      if (range === "YESTERDAY") {
        const start = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD");

        const end = moment().format("YYYY-MM-DD");

        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_WEEK") {
        const start = moment()
          .subtract(1, "weeks")
          .startOf("week")
          .format("YYYY-MM-DD");
        const end = moment()
          .subtract(1, "weeks")
          .endOf("week")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const startMonth = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const startMonth = moment()
          .subtract(1, "months")
          .startOf("month")
          .format("YYYY-MM-DD");
        const endMonth = moment()
          .subtract(1, "months")
          .endOf("month")
          .format("YYYY-MM-DD");
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_30_DAYS") {
        const start = moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "QUARTER") {
        const start = moment()
          .startOf("quarter")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "HALF_YEAR") {
        const start = moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "YEAR") {
        const start = moment()
          .subtract(1, "year")
          .format("YYYY-MM-DD");
        const end = moment().format("YYYY-MM-DD");
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
    },
    fetchTasksTimeChart() {
      this.ArTasksTimeData = [];
      if (!this.reqTasksTime) {
        this.reqTasksTime = true;
        let tempParams = this.getChartQueryObject;

        let colors = ["#e4fffb", "#bdffe7"];
        let MainChartCanvasId = "tasks-time-chart-big";
        let TotalChartCanvasId = "tasks-total-time-chart-big";

        apiClientCreator(`tasks/stats/tasks_times/users`)
          .get("", { params: tempParams })
          .then(res => {
            this.ArTasksTimeData = res.data;
            // this.ArTasksTimeData.users.forEach(user=>{
              // user.expected_time = this.adjustNumbersToFitDataChart(user.expected_time);
              // user.left_time = this.adjustNumbersToFitDataChart(user.left_time);
              // user.worked_time = this.adjustNumbersToFitDataChart(user.worked_time);
            // })
            // if(res.data.length > 1){
            //   this.tasksTimeCounter = res.data.tags.reduce((a, b) => a + b.count, 0);
            // }else{
            //   this.tagsTreeCounter = null;
            // }
            // this.ArTasksTimeData = [{ children: tempTagObj }];
            this.createTasksTimeChart(
              this.ArTasksTimeData,
              MainChartCanvasId,
              TotalChartCanvasId,
              this.TimeChartBarPerc
            );
            this.reqTasksTime = false;
          })
          .catch(err => {
            this.reqTasksTime = false;
          });
      }
    },

    createTasksTimeChart(Stats, mainCanvasId, TotalChartCanvasId, chartOpt) {
      let allData = Stats;
      let wrkTime = [];
      let expTime = [];
      let lftTime = [];
      let totalDataTime = [];
      let totalexpTime = [];
      let totallftTime = [];
      let UserLables = [];
      let TotalLables = ["SPT", "EST", "LFT"];
      let opt = chartOpt.options;

      allData.users.map(data => {
        wrkTime.push(data.worked_time);
        expTime.push(data.expected_time);
        lftTime.push(data.left_time);
        UserLables.push(data.user.full_name);
      });
      totalDataTime.push(allData.total.wrk_time);
      totalDataTime.push(allData.total.exp_time);
      totalDataTime.push(allData.total.left_time);

      const data = {
        labels: UserLables,
        datasets: [
          {
            type: "bar",
            label: "Expected Time",
            data: expTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(34,186,125)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            categoryPercentage: 0.9,
            barPercentage: 0.9,
            minBarLength: function(value) {
              if (value.dataset.data[value.dataIndex] > 0) {
                return 10;
              } else {
                return 5;
              }
            }
          },
          {
            type: "bar",
            label: "Time Worked On",
            data: wrkTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(34,110,186)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            categoryPercentage: 0.9,
            barPercentage: 0.9,
            minBarLength: function(value) {
              if (value.dataset.data[value.dataIndex] > 0) {
                return 20;
              } else {
                return 10;
              }
            }
          },

          {
            type: "bar",
            label: "Time Left",
            data: lftTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: "rgb(222,110,50)",
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 20,
            xAxisID: "bar-x-axis1",
            categoryPercentage: 0.9,
            barPercentage: 0.9,
            minBarLength: function(value) {
              if (value.dataset.data[value.dataIndex] > 0) {
                return 30;
              } else {
                return 15;
              }
            }
          }
        ]
      };

      const dataTotal = {
        labels: TotalLables,
        datasets: [
          {
            type: "bar",
            label: "Total",
            data: totalDataTime,
            fill: true,
            borderColor: "rgb(0, 13, 26)",
            backgroundColor: [
              "rgb(34,110,186)",
              "rgb(34,186,125)",
              "rgb(222,110,50)"
            ],
            borderWidth: 0,
            borderDash: [],
            borderDashOffset: 0.0,
            maxBarThickness: 40,
            xAxisID: "bar-x-axis1",
            minBarLength: function(value) {
              if (value.dataset.data[value.dataIndex] > 0) {
                return 20;
              } else {
                return 10;
              }
            }
          }
          // {
          //   type: "bar",
          //   label: "Expected Time",
          //   data:totalexpTime,
          //   fill: true,
          //   borderColor: "rgb(0, 13, 26)",
          //   backgroundColor: "rgb(34,186,125)",
          //   borderWidth: 0,
          //   borderDash: [],
          //   borderDashOffset: 0.0,
          //   maxBarThickness: 40,
          //   xAxisID: "bar-x-axis1"
          // },
          // {
          //   type: "bar",
          //   label: "Time Left",
          //   data:totallftTime,
          //   fill: true,
          //   borderColor: "rgb(0, 13, 26)",
          //   backgroundColor: "rgb(222,110,50)",
          //   borderWidth: 0,
          //   borderDash: [],
          //   borderDashOffset: 0.0,
          //   maxBarThickness: 40,
          //   xAxisID: "bar-x-axis1"
          // }
        ]
      };

      if (this.TasksTimeChartBuild) {
        this.TasksTimeChartBuild.destroy();
      }
      if (this.TasksTimeTotalChartBuild) {
        this.TasksTimeTotalChartBuild.destroy();
      }

      const ctx = document.getElementById(mainCanvasId);

      this.TasksTimeChartBuild = new Chart(ctx, {
        height: 260,
        type: chartOpt.type,
        data: data,
        options: opt,
        plugins: [ChartDataLabels]
      });

      const ctxTotal = document.getElementById(TotalChartCanvasId);
      this.TasksTimeTotalChartBuild = new Chart(ctxTotal, {
        height: 260,
        type: chartOpt.type,
        data: dataTotal,
        options: opt,
        plugins: [ChartDataLabels]
      });
    }
  }
};
</script>

<style scoped>
.right-list-rotate {
  /*transform: scaleX(-1);*/
}

.styleCard-big {
  width: 100%;
  height: 200px;
  font-family: Montserrat;
}
.styleCard-big.scroll {
  overflow-y: scroll;
}

.all_times_chart_container {
  width: 100% !important;
  padding-top: 12px;
  display: flex;
  flex-direction: row-reverse;
  /*flex-direction: column;*/
}

.active {
  background-color: #c12fff !important;
  color: white;
}
.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}

.date-nav li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.dropdown-item {
  /*margin-left: 15px;*/
  /*margin-right: 10px;*/
  height: 35px;
  min-height: 8%;
  outline: none;
  font-size: 12px;
  /*display: flex;*/
  /*text-align: left;*/
  transition: all 0.3s ease-in-out;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  transition-delay: 0s;
  border-radius: 0px 5px 5px 5px;
  background-color: white;
  border: 1px solid #e5e4e4;
  /*position: relative;*/
  /*z-index: 1;*/
}
.dropdown-item:hover {
  transform: translateX(-7px);
  border-radius: 0px 5px 5px 0px;
}

.sub-menu-dropup {
  left: -9px;
  bottom: 22px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 115px;
  border-radius: 0px;
  padding: 0px;
  max-height: 160px;
  min-height: 160px;
  text-transform: uppercase;
  /*transform: scaleX(-1);*/
}

.menu-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  height: 100% !important;
  background-color: #f5f5f5;
}

.menu-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
.menu-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 12px;
  /*padding-top: 12px;*/
  padding-right: 5px;
  /*padding-bottom: 12px;*/
  padding-left: 12px;
  margin-left: 5px;
  max-height: 195px;
}

.styleCardContentChart {
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  background: white;
  min-height: 300px;
  height: 100%;
}
.main-chart {
  width: 100%;
  height: 100%;
}
.styleCardContent-big {
  background: white;
  height: 300px;
}

.padding {
  /*padding-left: 1rem;*/
}
.time-users-chart {
  min-width: 65%;
  max-height: 100%;
}
.time-total-chart {
  min-width: 30%;
  max-height: 100%;
}
.flex {
  display: flex;
  align-items: stretch;
  background-color: #fff;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
}
.date-nav {
  max-width: 5%;
  min-width: 5%;
  max-height: 90%;
  min-height: 90%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 1;
}

.date-nav.style3 li {
  max-height: 10%;
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
  display: flex;
  /*justify-content:center;*/
  align-items: center;
}

.date-nav.style3 li:not(:last-child) {
  /*margin-right: 2px;*/
}

.date-nav li {
  max-width: 3%;
  min-width: 100%;
  max-height: 10%;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 10px;
  text-align: left;
  vertical-align: middle;
  /*line-height: 25px;*/
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
  margin-left: 3px;
}

.date-nav li:not(.empty):hover {
  transform: translateY(0px);
}

.date-nav li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}
</style>
